import * as React from "react";

function SvgDinoStanding(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 941 797"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      {...props}
    >
      <circle
        cx={1057.35}
        cy={1737.7}
        r={413.85}
        fill="#ffeee9"
        transform="matrix(.96237 0 0 .96247 -533.145 -1274.173)"
      />
      <circle
        cx={947.823}
        cy={1589.94}
        r={346.998}
        fillOpacity={0.25}
        transform="matrix(.83036 0 0 .07462 -303.197 536.764)"
      />
      <path
        d="M308.744 293.312c25.028-12.011-12.432 204.519-12.432 232.28 0 27.76-22.538 50.3-50.3 50.3-27.761 0-50.067-22.54-50.3-50.3-.522-90.764 61.724-207.659 113.032-232.28z"
        fill="#fe9e9b"
      />
      <g transform="matrix(1.17736 0 0 1.17736 -130.204 -334.71)">
        <clipPath id="dino_standing_svg___clip1">
          <path d="M372.825 533.416c21.258-10.202-10.559 173.71-10.559 197.289 0 23.579-19.143 42.723-42.722 42.723-23.58 0-42.526-19.145-42.723-42.723-.444-77.091 52.425-176.377 96.004-197.289z" />
        </clipPath>
        <g clipPath="url(#dino_standing_svg___clip1)">
          <ellipse
            cx={716.185}
            cy={713.203}
            rx={33.711}
            ry={33.625}
            fill="#fe8b88"
            transform="matrix(.39321 .24704 -.29062 .46258 212.856 187.004)"
          />
          <ellipse
            cx={716.185}
            cy={713.203}
            rx={33.711}
            ry={33.625}
            fill="#fe8b88"
            transform="matrix(.2241 .06077 -.048 .177 170.009 555.049)"
          />
          <ellipse
            cx={716.185}
            cy={713.203}
            rx={33.711}
            ry={33.625}
            fill="#fe8b88"
            transform="matrix(.24234 .06571 -.07491 .27626 229.453 356.586)"
          />
          <ellipse
            cx={716.185}
            cy={713.203}
            rx={33.711}
            ry={33.625}
            fill="#fe8b88"
            transform="matrix(.14998 .04067 -.04444 .16388 265.317 417.922)"
          />
        </g>
      </g>
      <path
        d="M252.172 571.094c-.712 3.207 10.629 12.991 13.917 11.754 3.289-1.237 7.786-15.675 5.21-17.644-2.577-1.97-18.414 2.684-19.127 5.89zM248.716 572.314c1.325 3.009-5.179 14.293-8.587 13.712-3.41-.582-12.642-12.005-9.395-16.29 1.921-2.536 16.658-.43 17.982 2.578zM226.258 567.406c.816 3.166-6.123 10.922-10.554 9.755-3.342-.881-8.514-15.43-4.957-19.46 2.106-2.386 14.49 5.742 15.511 9.705z"
        fill="#fd6b67"
      />
      <path
        d="M671.25 293.312c-25.029-12.011 12.431 204.519 12.431 232.28 0 27.76 22.538 50.3 50.299 50.3 27.762 0 50.068-22.54 50.3-50.3.523-90.764-61.723-207.659-113.03-232.28z"
        fill="#fe9e9b"
      />
      <g transform="matrix(-1.17736 0 0 1.17736 1110.197 -334.71)">
        <clipPath id="dino_standing_svg___clip2">
          <path d="M372.825 533.416c21.258-10.202-10.559 173.71-10.559 197.289 0 23.579-19.143 42.723-42.722 42.723-23.58 0-42.526-19.145-42.723-42.723-.444-77.091 52.425-176.377 96.004-197.289z" />
        </clipPath>
        <g clipPath="url(#dino_standing_svg___clip2)">
          <ellipse
            cx={716.185}
            cy={713.203}
            rx={33.711}
            ry={33.625}
            fill="#fe8b88"
            transform="matrix(-.48761 .36598 .3123 .4161 443.489 44.262)"
          />
          <ellipse
            cx={716.185}
            cy={713.203}
            rx={33.711}
            ry={33.625}
            fill="#fe8b88"
            transform="matrix(-.19964 .14984 .16154 .21523 344.773 379.246)"
          />
          <ellipse
            cx={716.185}
            cy={713.203}
            rx={33.711}
            ry={33.625}
            fill="#fe8b88"
            transform="matrix(-.2535 .19027 .23636 .31491 310.487 391.509)"
          />
        </g>
      </g>
      <path
        d="M727.534 571.094c.712 3.207-10.629 12.991-13.917 11.754-3.289-1.237-7.786-15.675-5.21-17.644 2.577-1.97 18.414 2.684 19.127 5.89zM730.988 572.314c-1.325 3.009 5.179 14.293 8.587 13.712 3.41-.582 12.642-12.005 9.396-16.29-1.922-2.536-16.659-.43-17.983 2.578zM753.446 567.406c-.816 3.166 6.123 10.922 10.554 9.755 3.343-.881 8.514-15.43 4.957-19.46-2.106-2.386-14.49 5.742-15.511 9.705z"
        fill="#fd6b67"
      />
      <g>
        <path
          d="M288.348 577.12c4.841 28.511 12.6 53.681 24.128 71.131 44.635 17.594 114.873 14.156 132.005-1.574 5.65-5.188 5.464-47.747 6.249-59.887-19.95-2.456-97.865-4.242-162.382-9.67z"
          fill="#fe9e9b"
        />
        <g transform="matrix(-1 0 0 1 1037.742 -209.916)">
          <clipPath id="dino_standing_svg___clip3">
            <path d="M749.396 787.037c-4.841 28.512-12.6 53.682-24.128 71.132-44.635 17.594-114.873 14.156-132.005-1.574-5.65-5.188-5.464-47.748-6.249-59.888 19.95-2.456 97.865-4.242 162.382-9.67z" />
          </clipPath>
          <g clipPath="url(#dino_standing_svg___clip3)">
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8b88"
              transform="matrix(.1214 -.48504 .37583 .09407 239.034 1128.44)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8b88"
              transform="matrix(.17203 -.10293 .07386 .12345 441.169 828.417)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8b88"
              transform="matrix(.26215 -.15685 .1279 .21375 430.004 774.938)"
            />
            <path
              d="M715.99 865.573c2.345-5.992-12.771-18.064-18.31-17.393-5.54.67-17.1 16.624-12.094 21.767 2.962 3.045 28.85-.403 30.404-4.374zM677.383 871.453c1.86-3.837-11.346-21.849-16.765-20.52-5.418 1.33-20.213 17.968-14.627 22.476 3.305 2.667 29.53 1.88 31.392-1.956zM636.127 870.323c2.343-3.505-9.243-21.677-14.788-21.067-5.545.61-21.543 13.895-16.59 18.997 2.93 3.02 29.033 5.574 31.378 2.07z"
              fill="#fc4a47"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M692.574 577.12c-4.84 28.511-12.6 53.681-24.128 71.131-44.634 17.594-114.872 14.156-132.004-1.574-5.65-5.188-5.464-47.747-6.25-59.887 19.95-2.456 97.866-4.242 162.382-9.67z"
          fill="#fe9e9b"
        />
        <g transform="matrix(1 0 0 1 -56.82 -209.916)">
          <clipPath id="dino_standing_svg___clip4">
            <path d="M749.396 787.037c-4.841 28.512-12.6 53.682-24.128 71.132-44.635 17.594-114.873 14.156-132.005-1.574-5.65-5.188-5.464-47.748-6.249-59.888 19.95-2.456 97.865-4.242 162.382-9.67z" />
          </clipPath>
          <g clipPath="url(#dino_standing_svg___clip4)">
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8b88"
              transform="matrix(-.33985 -.00926 -.00672 .2466 977.908 677.341)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8b88"
              transform="matrix(-.39471 .13081 .1093 .32982 840.224 514.025)"
            />
            <path
              d="M606.046 865.573c-2.345-5.992 12.772-18.064 18.31-17.393 5.54.67 17.1 16.624 12.094 21.767-2.961 3.045-28.85-.403-30.404-4.374zM644.65 871.453c-1.86-3.837 11.346-21.849 16.764-20.52 5.419 1.33 20.214 17.968 14.627 22.476-3.305 2.667-29.53 1.88-31.392-1.956zM685.906 870.323c-2.343-3.505 9.243-21.677 14.788-21.067 5.545.61 21.543 13.895 16.59 18.997-2.93 3.02-29.033 5.574-31.378 2.07z"
              fill="#fd6b67"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M578.957 194.731c4.819-17.994-20.763-48.397-29.128-53.651-8.334-5.234-25.92 13.185-21.066 22.127 4.855 8.942 48.455 36.44 50.194 31.524z"
          fill="#fd6b67"
        />
      </g>
      <g>
        <path
          d="M553.143 179.89c1.97-7.747-27.087-62.893-52.264-64.544-11.065-.726-20.529 35.72-11.819 46.477 8.71 10.757 62.113 25.813 64.083 18.067z"
          fill="#fd6b67"
        />
      </g>
      <path
        d="M283.028 566.256c10.707 70.062 406.484 69.456 415.074 0 10.19-82.382 3.493-186.567-1.556-214.876C678.06 247.75 595.831 158.59 490.565 158.06c-105.266.53-187.494 89.69-205.98 193.321-5.05 28.31-14.097 132.819-1.557 214.876z"
        fill="#feb4b2"
      />
      <g>
        <g transform="matrix(-1 0 0 1 1033.877 -211.144)">
          <clipPath id="dino_standing_svg___clip5">
            <path d="M750.852 777.401c-10.707 70.062-406.486 69.456-415.076 0-10.189-82.382-3.493-186.567 1.556-214.876 18.487-103.632 100.716-192.791 205.982-193.322 105.266.531 187.495 89.69 205.981 193.322 5.05 28.309 14.097 132.819 1.557 214.876z" />
          </clipPath>
          <g clipPath="url(#dino_standing_svg___clip5)">
            <ellipse
              cx={360.123}
              cy={778.252}
              rx={39.216}
              ry={31.424}
              fill="#fea5a3"
            />
            <ellipse
              cx={393.895}
              cy={732.103}
              rx={14.973}
              ry={14.725}
              fill="#fea5a3"
              transform="matrix(.8931 .22682 -.18934 .74549 179.578 100.094)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a3"
              transform="matrix(.84424 -.20693 .23195 .94633 -59.415 188.542)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a3"
              transform="matrix(.84711 .04306 -.0492 .96801 82.8 -308.915)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a3"
              transform="matrix(.34226 .10427 -.0859 .28195 504.375 487.89)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a3"
              transform="matrix(.25025 -.12328 .13025 .2644 398.112 508.517)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a3"
              transform="matrix(-.06356 .1502 -.17332 -.07334 823.797 676.675)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a3"
              transform="matrix(-.13102 .09712 -.10695 -.14428 545.206 709.712)"
            />
            <ellipse
              cx={522.817}
              cy={430.672}
              rx={20.488}
              ry={28.446}
              fill="#fea5a3"
              transform="rotate(-37.754 520.875 443.7)"
            />
            <ellipse
              cx={451.534}
              cy={438.87}
              rx={15.874}
              ry={8.198}
              fill="#fea5a3"
              transform="rotate(-22.303 451.535 438.869)"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M514.829 159.254c6.132 14.619-25.332 59.939-36.567 53.7-11.234-6.239-43.898-65.618-23.883-89.697 12-14.437 52.788 17.732 60.45 35.997z"
          fill="#fd6b67"
        />
      </g>
      <g>
        <g transform="matrix(1 0 0 .96613 -63.685 -216.237)">
          <path
            d="M553.53 683.824c61.782 1.299 112.473-49.452 106.219-86.332-6.136-36.179-70.806-23.619-106.209-23.619-35.403 0-100.073-12.56-106.208 23.619-6.255 36.88 44.416 85.032 106.198 86.332z"
            fill="#d9413d"
          />
          <clipPath id="dino_standing_svg___clip6">
            <path d="M553.53 683.824c61.782 1.299 112.473-49.452 106.219-86.332-6.136-36.179-70.806-23.619-106.209-23.619-35.403 0-100.073-12.56-106.208 23.619-6.255 36.88 44.416 85.032 106.198 86.332z" />
          </clipPath>
          <g clipPath="url(#dino_standing_svg___clip6)">
            <ellipse
              cx={523.887}
              cy={579.044}
              rx={14.697}
              ry={20.418}
              fill="#f2f0f0"
              transform="matrix(1.14611 0 0 1.44098 -66.32 -263.436)"
            />
            <ellipse
              cx={523.887}
              cy={579.044}
              rx={14.697}
              ry={20.418}
              fill="#f2f0f0"
              transform="matrix(1.14611 0 0 1.44098 -102.194 -263.436)"
            />
            <ellipse
              cx={523.887}
              cy={579.044}
              rx={14.697}
              ry={20.418}
              fill="#f2f0f0"
              transform="matrix(1.14611 0 0 1.44098 -137.295 -263.436)"
            />
            <ellipse
              cx={523.887}
              cy={579.044}
              rx={14.697}
              ry={20.418}
              fill="#f2f0f0"
              transform="matrix(1.14611 0 0 1.44098 -30.505 -263.436)"
            />
            <ellipse
              cx={523.887}
              cy={579.044}
              rx={14.697}
              ry={20.418}
              fill="#f2f0f0"
              transform="matrix(1.14611 0 0 1.44098 5.426 -263.436)"
            />
            <ellipse
              cx={523.887}
              cy={579.044}
              rx={14.697}
              ry={20.418}
              fill="#f2f0f0"
              transform="matrix(1.14611 0 0 1.44098 41.26 -263.436)"
            />
            <g transform="matrix(1.1829 .17977 -.15245 1.07471 74.17 53.943)">
              <ellipse
                cx={458.565}
                cy={497.513}
                rx={64.71}
                ry={38.577}
                fill="#f57370"
              />
            </g>
          </g>
        </g>
        <path d="M642.793 312.355c8.219 1.203 17.462-5.741 17.7-4.637 1.409 6.52-5.527 17.512-11.614 22.39l-6.086-17.753zM337.991 312.355c-8.219 1.203-17.461-5.741-17.7-4.637-1.408 6.52 5.527 17.512 11.614 22.39l6.086-17.753z" />
        <circle
          cx={427.545}
          cy={531.3}
          r={27.325}
          transform="matrix(-1.04746 0 0 1.04746 1070.943 -226.417)"
        />
        <circle
          cx={427.545}
          cy={531.3}
          r={27.325}
          transform="matrix(-1.04746 0 0 1.04746 804.827 -226.417)"
        />
        <circle
          cx={437.886}
          cy={527.93}
          r={10.341}
          fill="#fff"
          transform="matrix(-1.04746 0 0 1.04746 1074.24 -226.995)"
        />
        <circle
          cx={437.886}
          cy={527.93}
          r={10.341}
          fill="#fff"
          transform="matrix(-1.04746 0 0 1.04746 808.123 -226.995)"
        />
      </g>
      <g>
        <path
          d="M291.451 899.885c28.694-54.334 75.401-101.864 137.51-138.356"
          fill="none"
          stroke="#bcdad1"
          strokeWidth={8.61}
          transform="matrix(.40772 -.83502 .83503 .40772 -781.355 297.351)"
        />
        <path
          d="M27.19 197.72c4.448-.154 8.668 17.366 9.172 32.007.505 14.641-2.896 20.895-7.344 21.048-4.448.154-8.272-5.851-8.776-20.493-.505-14.64 2.499-32.41 6.948-32.562zM56.51 252.373c3.897 1.533.917 18.4-4.182 31.363-5.099 12.964-12.733 15.594-16.631 14.06-3.898-1.532-2.592-6.652 2.507-19.615 5.099-12.963 14.408-27.341 18.306-25.808zM65.735 309.096c4.693.475 6.613 19.538 5.045 35.035-1.57 15.498-9.043 20.634-13.737 20.158-4.694-.475-4.842-6.382-3.273-21.88 1.569-15.497 7.27-33.789 11.965-33.313zM96.785 360.474c5.035.044 8.936 21.708 8.78 39.654-.156 17.947-7.6 24.637-12.636 24.593-5.036-.044-5.77-6.805-5.613-24.752.156-17.946 4.433-39.539 9.469-39.495z"
          fill="#bcdad1"
        />
        <path
          d="M32.678 396.13c-2.411 4.01 14.005 18.317 29.252 27.487 15.247 9.17 24.522 6.741 26.934 2.73 2.412-4.01-2.947-8.091-18.194-17.262-15.247-9.17-35.58-16.966-37.992-12.955zM12.347 325.162c-3.5 3.122 6.672 20.24 17.47 32.342 10.798 12.102 19.992 12.077 23.492 8.955 3.5-3.123-.014-8.168-10.812-20.27-10.797-12.1-26.65-24.15-30.15-21.027zM.836 259.56c-3.344 2.521 4.046 17.973 12.432 29.096 8.386 11.124 16.446 11.612 19.79 9.09 3.345-2.521.715-7.103-7.67-18.227C17.001 268.397 4.18 257.04.835 259.56z"
          fill="#bcdad1"
        />
        <g>
          <path
            d="M258.694 1046.24c-5.263-114.531 56.797-218.043 170.267-284.711"
            fill="none"
            stroke="#66a09e"
            strokeWidth={8.32}
            transform="matrix(.95182 -.13725 .13725 .95182 -301.957 -525.501)"
          />
          <path
            d="M240.777 117.468c2.588 3.535-5.742 14.041-14.397 20.377-8.656 6.336-14.38 6.118-16.968 2.583-2.588-3.536-1.066-9.059 7.59-15.395 8.655-6.336 21.187-11.1 23.775-7.565zM220.262 167.55c1.314 5.804-12.831 13.961-25.454 16.82-12.623 2.858-19.3-4.577-20.615-10.382-1.314-5.804 3.23-7.793 15.853-10.651 12.622-2.858 28.902-1.59 30.216 4.214zM185.373 211.866c2.114 5.633-13.613 16.753-28.087 22.185-14.475 5.432-23.022-.785-25.136-6.42-2.114-5.633 3-8.563 17.475-13.995 14.474-5.432 33.634-7.404 35.748-1.77zM161.358 268.032c2.69 6.119-15.619 20.093-32.622 27.567-17.004 7.473-27.347 1.313-30.036-4.807-2.69-6.12 3.286-9.894 20.29-17.368 17.003-7.473 39.678-11.511 42.368-5.392z"
            fill="#66a09e"
          />
          <path
            d="M73.649 231.45c-6.22 2.144-4.036 24.863 1.966 42.27 6.003 17.407 17.382 20.813 23.603 18.668 6.22-2.145 4.939-9.032-1.064-26.44-6.002-17.407-18.285-36.644-24.505-34.499zM44.211 311.794c-5.65 3.496 1.437 25.205 11.126 40.862 9.689 15.659 21.622 16.423 27.273 12.926 5.652-3.497 2.894-9.939-6.795-25.597-9.688-15.658-25.952-31.688-31.604-28.191z"
            fill="#66a09e"
          />
          <path
            d="M147.087 324.75c3.472 5.078-13.995 23.07-30.827 34.579-16.833 11.509-28.259 8.393-31.731 3.314-3.473-5.078 2.316-10.208 19.15-21.717 16.831-11.508 39.936-21.254 43.408-16.176zM141.923 384.681c5.097 4.91-8.672 27.488-23.532 42.913-14.86 15.426-27.927 14.03-33.025 9.12-5.098-4.912-.308-11.489 14.553-26.915 14.859-15.425 36.906-30.029 42.004-25.118z"
            fill="#66a09e"
          />
          <path
            d="M21.883 403.344c-4.022 7.125 15.17 25.588 33.805 36.107 18.636 10.519 31.548 4.027 35.57-3.1 4.023-7.126-2.357-12.205-20.993-22.724-18.635-10.519-44.36-17.41-48.382-10.283zM127.147 163.872c-5.716-.233-11.18 19.724-11.861 36.44-.682 16.718 7.445 23.351 13.162 23.584 5.718.233 6.873-6.02 7.555-22.738.681-16.717-3.139-37.053-8.856-37.286zM173.567 127.828c-5.34.198-9.134 14.95-8.686 27.059.45 12.109 8.45 16.375 13.79 16.177 5.34-.198 6.01-4.786 5.562-16.894-.449-12.109-5.325-26.54-10.666-26.342z"
            fill="#66a09e"
          />
        </g>
      </g>
      <g>
        <path
          d="M265.24 970.652c25.212-82.597 81.542-156.433 163.721-209.123"
          fill="none"
          stroke="#66a09e"
          strokeWidth={10.6}
          transform="matrix(-.35272 -.67977 -.65961 .34226 1528.549 492.935)"
        />
        <path
          d="M877.988 428.499c-4.968-.508-9.952 11.4-10.74 21.622-.789 10.224 2.915 14.916 7.882 15.424 4.969.509 9.333-3.359 10.121-13.582.789-10.223-2.295-22.956-7.263-23.464zM850.615 465.938c-4.3 1.801-2.386 15.997 2.1 26.562 4.486 10.565 12.48 11.9 16.78 10.098 4.301-1.802 3.29-6.061-1.197-16.627-4.485-10.565-13.383-21.835-17.683-20.033zM836.45 510.058c-4.199 1.937-.878 17.38 4.706 28.89 5.585 11.509 13.845 13 18.045 11.062 4.2-1.938 2.758-6.573-2.826-18.083-5.585-11.51-15.725-23.807-19.925-21.87zM819.132 548.526c-6.07.889-8.022 19.087-5.552 33.588 2.47 14.503 12.303 18.657 18.374 17.768 6.072-.888 6.096-6.485 3.626-20.987-2.47-14.502-10.377-31.257-16.448-30.369z"
          fill="#66a09e"
        />
        <path
          d="M882.176 586.14c1.765 5.217-13.392 15.163-27.158 19.902-13.767 4.739-21.536-1.127-23.302-6.344-1.765-5.217 3.138-7.82 16.905-12.56 13.766-4.738 31.79-6.214 33.555-.997zM849.946 647.826c.961 6.337-17.631 14.052-33.707 16.183-16.076 2.132-23.536-6.36-24.498-12.698-.962-6.338 4.937-8.137 21.013-10.268 16.075-2.132 36.23.445 37.192 6.783z"
          fill="#66a09e"
        />
        <path
          d="M788.403 590.662c-6.271-.419-12.095 19.18-12.702 35.725-.607 16.546 8.36 23.388 14.633 23.807 6.272.42 7.486-5.74 8.093-22.287.608-16.545-3.752-36.825-10.024-37.245zM896.496 522.197c2.866 3.632-6.922 16.566-16.976 24.85-10.054 8.285-18.041 6.076-20.908 2.443-2.867-3.633.465-7.322 10.52-15.606 10.053-8.285 24.497-15.32 27.364-11.687zM897.71 469.596c3.284 2.412-1.781 15.45-8.197 24.644-6.416 9.193-13.647 9.114-16.931 6.701-3.285-2.413-1.387-6.252 5.029-15.446 6.416-9.193 16.814-18.313 20.1-15.9z"
          fill="#66a09e"
        />
        <g>
          <path
            d="M258.694 1046.24c14.326-106.639 81.635-208.036 170.267-284.711"
            fill="none"
            stroke="#bcdad1"
            strokeWidth={11}
            transform="matrix(-.1343 -.71458 -.71458 .1343 1524.519 747.996)"
          />
          <path
            d="M938.121 518.53c-3.735-2.24-12.683 5.802-17.592 13.985-4.908 8.183-3.93 13.428-.195 15.668 3.736 2.241 8.824.635 13.732-7.548 4.909-8.183 7.791-19.864 4.055-22.105zM895.64 536.44c-4.474.477-6.855 12.59-5.817 22.321 1.038 9.73 7.99 12.692 12.464 12.215 4.474-.477 4.787-4.214 3.749-13.945-1.038-9.73-5.922-21.069-10.396-20.591zM872.452 567.29c-4.547-.137-8.662 13.833-9.013 25.516-.35 11.684 6.185 16.281 10.733 16.418 4.548.137 5.395-4.239 5.746-15.923.351-11.683-2.918-25.874-7.466-26.011zM834.999 595.882c-5.052.114-8.772 17.126-8.454 31.165.317 14.04 7.846 19.156 12.898 19.042 5.053-.115 5.728-5.416 5.41-19.456-.317-14.039-4.801-30.865-9.854-30.751z"
            fill="#bcdad1"
          />
          <path
            d="M890.456 652.44c-.015 4.974-16.805 8.961-30.726 8.918-13.922-.042-19.138-7.353-19.123-12.327.015-4.975 5.256-5.741 19.178-5.698 13.922.042 30.687 4.132 30.671 9.107zM846.224 700.099c-1.322 5.775-20.783 6.254-36.04 2.76-15.258-3.494-19.06-13.28-17.737-19.056 1.323-5.776 7.272-5.37 22.53-1.875 15.257 3.494 32.57 12.394 31.247 18.17z"
            fill="#bcdad1"
          />
          <path
            d="M801.987 627.233c-4.48-1.244-13.088 15.65-17.211 30.504-4.124 14.856.897 22.27 5.379 23.515 4.482 1.244 6.738-4.151 10.861-19.007 4.123-14.855 5.454-33.768.971-35.012zM762.596 652.477c-4.759-2.448-17.55 12.92-24.958 27.32-7.408 14.4-3.217 23.41 1.542 25.858 4.76 2.448 8.296-2.586 15.704-16.987 7.407-14.4 12.471-33.743 7.712-36.191z"
            fill="#bcdad1"
          />
          <path
            d="M780.797 743.171c-4.116 4.619-22.014-4.604-34.093-15.369-12.08-10.765-10.588-21.59-6.471-26.209 4.116-4.619 9.309-1.294 21.388 9.471 12.079 10.765 23.293 27.488 19.176 32.107zM922.988 608.476c.357 4.438-14.549 9.265-27.157 10.28-12.61 1.014-17.879-5.113-18.236-9.552-.357-4.44 4.332-5.519 16.941-6.534 12.61-1.014 28.095 1.367 28.452 5.806zM940.549 565.224c1.163 3.869-9.784 10.584-19.65 13.549-9.867 2.965-15.285-1.594-16.448-5.463-1.163-3.87 2.367-5.594 12.234-8.56 9.866-2.964 22.701-3.396 23.864.474z"
            fill="#bcdad1"
          />
        </g>
      </g>
      <g>
        <path
          d="M301.069 875.229c31.852-43.312 76.206-79.182 127.892-113.7"
          fill="none"
          stroke="#66a09e"
          strokeWidth={7.82}
          transform="matrix(.21558 -.73675 -.73675 -.21558 1213.38 1179.682)"
        />
        <path
          d="M760.932 682.225c-2.839-2.772-11.466 1.454-16.711 6.828-5.246 5.373-5.137 9.873-2.298 12.645 2.84 2.772 7.34 2.772 12.587-2.602 5.245-5.373 9.262-14.1 6.422-16.871zM720.866 691.464c-4.023-.755-9.42 9.976-11.186 19.39-1.767 9.413 3.468 14.063 7.492 14.818 4.024.756 5.322-2.668 7.089-12.082 1.766-9.413.629-21.37-3.395-22.126zM686.514 710.075c-3.757-1.035-10.468 11.417-13.504 22.447-3.037 11.03 1.33 16.697 5.088 17.732 3.758 1.035 5.491-2.953 8.528-13.983 3.037-11.03 3.646-25.162-.112-26.196zM647.569 728.25c-4.466-1.902-14.184 10.86-19.238 22.73-5.055 11.872-.408 19.128 4.06 21.03 4.466 1.902 7.07-2.266 12.125-14.138 5.055-11.87 7.52-27.72 3.053-29.622z"
          fill="#66a09e"
        />
        <path
          d="M671.955 790.552c-1.944 4.352-18 1.418-30.012-3.95-12.013-5.367-13.682-13.77-11.737-18.122 1.945-4.353 6.771-3.017 18.784 2.35 12.012 5.367 24.91 15.37 22.965 19.722zM718.937 755.127c-.497 4.307-15.413 6.131-27.456 4.743s-15.847-8.227-15.35-12.535c.496-4.307 5.106-4.462 17.15-3.074 12.042 1.388 26.152 6.558 25.656 10.866zM748.143 720.14c.695 3.695-10.46 8.899-20.184 10.728-9.725 1.829-14.404-2.9-15.099-6.595-.695-3.695 2.856-4.964 12.58-6.793 9.725-1.83 22.008-1.034 22.703 2.66z"
          fill="#66a09e"
        />
      </g>
    </svg>
  );
}

export default SvgDinoStanding;
